import {useGetConsumables} from '@/modules/products/consumables/api'
import {mapConsumablesToSelectItems} from '@/modules/products/consumables/functions'
import {getTradeNameFormDefaultValues} from '@/modules/products/trade-names/functions'
import {Box, Button, HStack, IconButton} from '@chakra-ui/react'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'
import {LuPlus, LuTrash2} from 'react-icons/lu'

export const TradeNameConsumablesTab = withForm({
  defaultValues: getTradeNameFormDefaultValues(undefined),
  render: function Render({form}) {
    const {t} = useTranslate('common')
    const {t: tTradeNames} = useTranslate('trade-names')
    const {consumables} = useGetConsumables()
    const consumableSelectItems = mapConsumablesToSelectItems(consumables)

    return (
      <FormSection label={t('consumables')} description={tTradeNames('consumables_description')}>
        <form.Field name="consumables" mode="array">
          {field => (
            <>
              {!field?.state?.value?.length && <EmptyState title={t('no_consumables_added_yet')} />}

              {field?.state?.value?.map((consumable, index) => {
                const filteredItems = consumableSelectItems.filter(item => {
                  const isSelectedInAnotherRow = field.state?.value?.some(
                    (val, i) => val.id === item.value && i !== index
                  )
                  return !isSelectedInAnotherRow
                })

                return (
                  <HStack key={consumable.id} alignItems="flex-end" gap="4" width="max-content">
                    <Box maxWidth="4rem">
                      <form.AppField name={`consumables[${index}].units`} mode="value">
                        {subField => <subField.NumberInput label={t('qty')} min={1} required />}
                      </form.AppField>
                    </Box>

                    <form.AppField name={`consumables[${index}].id`} mode="value">
                      {subField => (
                        <subField.Select
                          flex="1"
                          label={t('product')}
                          items={filteredItems}
                          placeholder={t('eg', {value: consumableSelectItems?.[0]?.label})}
                          portalled={false}
                          required
                          minWidth="20rem"
                          maxWidth="20rem"
                        />
                      )}
                    </form.AppField>

                    <IconButton
                      variant="ghost"
                      colorPalette="red"
                      onClick={() => field.removeValue(index)}
                      aria-label={t('remove')}
                      mb="0.5"
                    >
                      <LuTrash2 />
                    </IconButton>
                  </HStack>
                )
              })}

              <Button
                size="sm"
                variant="ghost"
                colorPalette="cyan"
                onClick={() => field.pushValue({id: '', units: 1})}
                mt="2"
              >
                <LuPlus />
                {t('add_new')}
              </Button>
            </>
          )}
        </form.Field>
      </FormSection>
    )
  },
})
